<div class="harp-loader-wrapper">
  <div class="loader">
    {{ defaultLoadingMsg }}
  </div>
</div>
<!-- Screen Reader Loading Message -->
<div role="status" class="visually-hidden">
  {{ defaultLoadingMsg }}
</div>
